import React , {useState , useContext}from 'react'
import TopBaner from '../TopBaner/topBaner';
import SideBar from '../SideBar/sideBar';
import Footer from '../Footer/Footer';
import emailjs from 'emailjs-com';
import CircularProgress from '@mui/material/CircularProgress';
import Context from '../../context/context';

function AskOrbit() {

    const [comment,setComment] = useState('');
    const [phone, setPhone] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const {state, dispatch} = useContext(Context);


    const handleSend = () => {
      if(!phone){
        alert("חובה לציין מספר טלפון")
      }else{
         setIsLoading(true);
        const templateParams = {
          from_name : state.email , 
          comment: comment , 
          phone : phone 
        };
    
        emailjs
          .send('AskOrbits', 'template_aqgkv7d', templateParams, 'Awn2UEURtJzV-xy2K')
          .then((response) => {
            setIsLoading(false);
            alert('המשוב נשלח בהצלחה');
          })
          .catch((error) => {
            alert('שגיאה בשליחת המשוב:', error);
          });
      }
       
      };

      const handleChange = (event) => {
        setComment(event.target.value); 
      };

      const onChangePhone = (event) => {
        const input = event.target.value;
        const phoneRegex = /^[0-9]*$/;
        if (phoneRegex.test(input)) {
          setPhone(input);
        }else{
            alert("  מספרים בלבד");  
        }
      };

  return (
    <div>
      <TopBaner></TopBaner>
      <SideBar></SideBar>
      {isLoading && (
                            <div style={{ position: 'relative' }}>
                                <div
                                    style={{
                                        position: 'fixed',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        zIndex: 9999,
                                        padding: '20px',
                                        borderRadius: '8px',
                                    }}
                                >
                                    <CircularProgress sx={{ color: '#3422F2' }} size={200} />
                                </div>
                            </div>
                        )}
      <div className='card commentsDiv' style={{direction: "rtl"}}>
        <div style={{ 'textAlign': 'center'}}>
                <img src="pycBlueIogo.png" alt="logo-pych" style={{height :'100px'}}/>
        </div>
        <h3>בקש מסלול</h3>
        <p>לא מצאת הסעה שתואמת את המסלול שלך?</p>
        <p>מוזמן/ת לכתוב לנו כאן ואנחנו נשמח לעזור בכל עניין.</p>
        <input
         required
         placeholder='טלפון*'
         className="invitationInput invitationInputPhone"
         type="text"
         value={phone}
         onChange={onChangePhone}
       />
        <textarea
          className='invitationInput'
          placeholder="ציין שם מסלול , תאריך ושעה *"
          rows={4}
          style={{ direction: 'rtl' , height : '100px' , width: '300px' }}
          value={comment}
          onChange={handleChange}
        />
        <button
        className='optionsBtn commentsBtn'
        style={{marginLeft : '-20px'}}
        variant="contained"
        sx={{ mt: 1, mr: 1 }}
        onClick={handleSend}
        >
          שלח
        </button>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default AskOrbit